/**
 * Stepper Component
 * Multi-step indicator for the connect-a-source wizard.
 */

import React from 'react';

interface Step {
  name: string;
  description?: string;
}

interface StepperProps {
  steps: Step[];
  currentStep: number;
  onStepClick?: (step: number) => void;
}

export const Stepper: React.FC<StepperProps> = ({ steps, currentStep, onStepClick }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', width: '100%' }}>
      {steps.map((step, index) => {
        const done = index < currentStep;
        const current = index === currentStep;
        const upcoming = index > currentStep;

        return (
          <React.Fragment key={index}>
            <div style={{ textAlign: 'center', width: 88, flex: 'none' }}>
              <button
                onClick={() => onStepClick && onStepClick(index)}
                disabled={!onStepClick || upcoming}
                style={{
                  width: 30,
                  height: 30,
                  borderRadius: 10,
                  display: 'grid',
                  placeItems: 'center',
                  fontSize: 11,
                  fontWeight: 800,
                  margin: '0 auto 7px',
                  transition: '.14s',
                  cursor: onStepClick && !upcoming ? 'pointer' : 'default',
                  background: done
                    ? 'var(--green-s)'
                    : current
                    ? 'var(--blue)'
                    : 'rgba(14,18,22,.055)',
                  color: done ? '#0A7A55' : current ? '#fff' : 'var(--muted-2)',
                  boxShadow: current ? '0 4px 12px rgba(35,84,240,.28)' : 'none',
                }}
              >
                {done ? (
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2.6}
                    strokeLinecap="round"
                  >
                    <path d="m5 13 4 4L19 7" />
                  </svg>
                ) : (
                  index + 1
                )}
              </button>
              <div
                style={{
                  fontSize: 11.5,
                  fontWeight: 700,
                  color: upcoming ? 'var(--muted-2)' : 'var(--ink)',
                }}
              >
                {step.name}
              </div>
              {step.description && (
                <div style={{ fontSize: 10.5, color: 'var(--muted-2)', marginTop: 1 }}>
                  {step.description}
                </div>
              )}
            </div>

            {index < steps.length - 1 && (
              <div
                style={{
                  flex: 1,
                  height: 2,
                  marginTop: 14,
                  borderRadius: 2,
                  background: index < currentStep ? 'var(--green)' : 'rgba(14,18,22,.08)',
                  transition: '.2s',
                }}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};
